var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21853",
    "data-name": "\\uADF8\\uB8F9 21853",
    transform: "translate(-1095 -731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21265",
    "data-name": "\\uADF8\\uB8F9 21265",
    transform: "translate(-356 670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9838",
    "data-name": "\\uD328\\uC2A4 9838",
    d: "M0,0H24V24H0Z",
    transform: "translate(1451 61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21849",
    "data-name": "\\uADF8\\uB8F9 21849",
    transform: "translate(87.951 -62.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_28201",
    "data-name": "\\uC0AC\\uAC01\\uD615 28201",
    d: "M2.083,0H18.077A2.083,2.083,0,0,1,20.16,2.083v9.471a2.084,2.084,0,0,1-2.084,2.084H2.084A2.084,2.084,0,0,1,0,11.554V2.083A2.083,2.083,0,0,1,2.083,0Z",
    transform: "translate(1009.049 800.52)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10303",
    "data-name": "\\uD328\\uC2A4 10303",
    d: "M288.631,195.52l.786-2.365a1.348,1.348,0,0,1,1.122-.6h5.672a1.348,1.348,0,0,1,1.122.6l.786,2.365",
    transform: "translate(725.754 605)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10304",
    "data-name": "\\uD328\\uC2A4 10304",
    d: "M297.576,210.31a17.878,17.878,0,0,1-7,1.307,17.684,17.684,0,0,1-6.039-.989",
    transform: "translate(727.965 595.425)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.4e88968313c7cdaf2aa670a330eaae67.svg";
export { ForwardRef as ReactComponent };